import React, { useEffect } from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'
import { useHistory, useLocation } from 'react-router-dom'

import { Profile } from '../../../../data/profile/data-types'
import { useProfile } from '../../../../data/hooks/profile'
import Loader from '../../loader'

import ProfileInfo from './profile-info'

type ProfileDialogProps = {
  profile?: Profile
  publicId?: string
}

const ProfileDialog: React.FunctionComponent<ProfileDialogProps> = ({ profile, publicId }) => {
	const history = useHistory()
	const location = useLocation()

	const { pending, error, data } = useProfile(publicId!)

	
	if (!profile) {
		profile = data
	}

	useEffect(() => {
		if (!profile?.public_id) {
			return
		}

		window.history.pushState({}, `${profile?.first_name} ${profile?.last_name}`, `/profile/${profile?.public_id}`)
		
		return () => {
			if (window.location.pathname === `/profile/${profile?.public_id}`) {
				history.replace(location)
			}
		}
	}, [profile?.public_id])

	return (
		<Container>
			{ pending && !profile && <Loader />}
			{ profile && <ProfileInfo profile={profile!}/> }
		</Container>
	)
}

const Container = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
    max-width: 1024px;

	padding: 24px;

	${up('tablet')} {
		padding: 64px;
	}
`



export default ProfileDialog